angular.module('impactx.treeselect').component('ixTreeSelect', {
        bindings: {
            tree: '<',
            onSelectedItemChange: '&',
            onLevelChange: '&',
        },
        controller: 'TreeSelectCtrl',
        templateUrl: 'shared/treeselect/templates/tree-select.html'
    }
);